export default __webpack_public_path__ + "static/media/missionBanner.8bc2a130.jpg";